var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"800px"},attrs:{"src":"https://video.mz.test.tu-dresden.de/cache/0dab66794a20148b57cead2c1d564431.jpg"}})}
var staticRenderFns = []

export { render, staticRenderFns }